import "@babel/polyfill";
import Swiper from "swiper";

import purpleLogo from '../../assets/images/logo-purple-text.png';
import whiteLogoTextOnly from '../../assets/images/logo-white-text-only.png';
import whiteLogoText from '../../assets/images/logo-white-text.png';

import testimonialsKate from "../../assets/images/testimonials-kate.jpeg";
import testimonialsRoma from "../../assets/images/testimonials-roman.png";
import testimonialsStav from "../../assets/images/testimonials-stav.jpg";


// JS
import 'bootstrap'
import "../../template/js/template";
import HomeCtaHandler from "./home-cta-handler";
import PreLoaderHandler from "../../template/js/preloader-handler";
import PartnershipModal from "./partnership/partnership-modal";
import ToastHandler from "../../template/js/toast-handler";
import ErrorModal from "../../template/js/error/error-modal";
import ErrorHandler from "../../template/js/error/error-handler";
import HomePicksHandler from "./home-picks-handler";
import SignInModal from "../../template/js/sign-in-modal/sign-in-modal";
import MessageModal from "../../template/js/message-modal/message-modal";

// CSS
import '../scss/home-style.scss'
import Cookies from "js-cookie";
import {v4 as uuidv4} from "uuid";


(function ($) {
    "use strict";

    let tempCookieId = Cookies.get('tempCookieId');
    const urlParams = new URLSearchParams(window.location.search);
    const referrer = urlParams.get('referrer');
    // if (tempCookieId && !referrer && window.location.href) {
    //     window.location.href = APP_URL;
    // }
    if (!tempCookieId) {
        tempCookieId = uuidv4();
        Cookies.set('tempCookieId', tempCookieId, {expires: 365});
    }
    const refId = urlParams.get('refId');
    if (refId) {
        Cookies.set('refId', refId, {expires: 365});
    }

    /**
     * ----------------------------------------------
     * Testimonial swiper slider
     * ----------------------------------------------
     */
    testimonialSlider();

    /**
     * ----------------------------------------------
     * Nav Scroll active section class call
     * ----------------------------------------------
     */
    windowScroll();

    navbar();

    reLoadImages();
    const signInModal = new SignInModal(true);
    const errorModal = new ErrorModal();
    const errorHandler = new ErrorHandler(errorModal);
    errorHandler.init();
    const messageModal = new MessageModal();
    new HomeCtaHandler(tempCookieId, messageModal).init();
    const preLoaderHandler = new PreLoaderHandler();
    preLoaderHandler.hide();
    const toastHandler = new ToastHandler();
    new PartnershipModal(preLoaderHandler, toastHandler, errorHandler).init();
    const homePicksHandler = new HomePicksHandler(signInModal);
    homePicksHandler.init();
})(jQuery);


/**
 * ----------------------------------------------
 * Nav Scroll active section class
 * ----------------------------------------------
 */
function windowScroll() {
    $(window).on('scroll', function () {
        const scrollPos = $(this).scrollTop();
        const width = window.screen.width;
        const mission = $("#mission");
        if (scrollPos >= 20) {
            $(".header").addClass("fixed-nav");
            $(".header .navbar-brand-white").addClass("navbar-brand-purple").removeClass("navbar-brand-white");
        } else {
            $(".header").removeClass("fixed-nav");
            $(".header .navbar-brand-purple").addClass("navbar-brand-white").removeClass("navbar-brand-purple");
        }
        if (mission.length && (scrollPos > mission.offset().top - 50) && (scrollPos < mission.offset().top + mission.height())) {
            skillsProgress();
        }
    })
}

/**
 * ----------------------------------------------
 * Testimonial swiper slider
 * ----------------------------------------------
 */
function testimonialSlider() {
    new Swiper('.testimonials-slider-4', {
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
}

/**
 * ----------------------------------------------
 * Skills progress bar
 * ----------------------------------------------
 */
function skillsProgress() {
    $(".skills-progress span").each(function () {
        const dataValue = $(this).attr("data-value");
        $(this).width(dataValue).addClass('show-width');
    })
}


function navbar() {
    $('.nav-link').on('click', function () {
        $('.navbar-collapse').collapse('hide');
    });
}

function reLoadImages() {
    $('img[data-lazysrc]').each(function () {
            //* set the img src from data-src
            $(this).attr('src', $(this).attr('data-lazysrc'));
        }
    );
}
